import React from "react";
export default function PhoneIcon() {
  return (
    <div style={{ marginLeft: "10px" }}>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.955 20.528C13.1742 20.838 14.4271 20.9958 15.685 20.998C16.4439 21.0104 17.2026 20.9669 17.955 20.868C18.7795 20.7304 19.3815 20.0139 19.375 19.178V15.818C19.3806 14.3291 18.1839 13.1145 16.695 13.098H14.695C14.4112 13.0964 14.1545 13.2662 14.045 13.528L13.195 15.528C13.139 15.6711 12.9811 15.7457 12.835 15.698C9.12467 14.5714 6.35654 11.4635 5.66503 7.64805C5.65258 7.51643 5.73072 7.39305 5.85503 7.34805L8.03503 6.34805C8.29353 6.23999 8.46269 5.98821 8.46503 5.70805V3.70805C8.46512 2.22299 7.27 1.01449 5.78503 0.998047H2.62503C1.85104 1.00923 1.18359 1.54484 1.00503 2.29805C0.751414 3.42034 0.623957 4.56745 0.625033 5.71805C0.623049 6.66412 0.710099 7.60828 0.885033 8.53805C1.93952 14.3423 6.25319 19.0145 11.955 20.528ZM2.33503 2.60831C2.37178 2.47986 2.49153 2.39315 2.62503 2.39831H5.78503C6.49909 2.40927 7.07061 2.99419 7.06503 3.70831V5.22831L5.29503 5.99831C4.56344 6.30894 4.14716 7.08738 4.29503 7.86831C5.07264 12.2293 8.24065 15.7802 12.485 17.0483C13.308 17.262 14.1622 16.8349 14.485 16.0483L15.155 14.4583H16.635C16.9798 14.4636 17.3084 14.6056 17.5485 14.8532C17.7885 15.1007 17.9204 15.4335 17.915 15.7783V19.1383C17.923 19.2814 17.8253 19.4089 17.685 19.4383C15.8789 19.7192 14.0343 19.6273 12.265 19.1683C7.10166 17.7851 3.20404 13.5406 2.26503 8.27831C2.10216 7.43478 2.02178 6.57741 2.02503 5.71831C2.01624 4.67351 2.12018 3.63081 2.33503 2.60831Z"
          fill="#12344D"
        />
      </svg>
    </div>
  );
}
